import React, {Component} from 'react';
import {
  Link
} from "react-router-dom";
import tempeJP2 from '../../assets/images/tempe/tempe-campus.jp2';
import tempeJPG from '../../assets/images/tempe/tempe-campus.jpg';
import tempeJXR from '../../assets/images/tempe/tempe-campus.jxr';
import tempeWEBP from '../../assets/images/tempe/tempe-campus.webp';
import downtownJP2 from '../../assets/images/downtown/downtown-campus.jp2';
import downtownJPG from '../../assets/images/downtown/downtown-campus.jpg';
import downtownJXR from '../../assets/images/downtown/downtown-campus.jxr';
import downtownWEBP from '../../assets/images/downtown/downtown-campus.webp';
import polytechnicJP2 from '../../assets/images/polytechnic/polytechnic-campus.jp2';
import polytechnicJPG from '../../assets/images/polytechnic/polytechnic-campus.jpg';
import polytechnicJXR from '../../assets/images/polytechnic/polytechnic-campus.jxr';
import polytechnicWEBP from '../../assets/images/polytechnic/polytechnic-campus.webp';
import westJP2 from '../../assets/images/west-campus/west-campus.jp2';
import westJPG from '../../assets/images/west-campus/west-campus.jpg';
import westJXR from '../../assets/images/west-campus/west-campus.jxr';
import westWEBP from '../../assets/images/west-campus/west-campus.webp';
import Heading from '../../components/Heading/Heading.js';

class ComingSoon extends Component {

  constructor(props) {
    super(props);
    // initial state
    this.state = {
        showPoly: true,
        showTempe: false, 
        showDowntown: true, 
        showWest: true
    };
  }

  componentDidMount(){
    this.hideCampus(this.props.hide)
  }

  hideCampus(childData)  {
    if(childData === "tempe"){
      this.setState({ 
        showDowntown: true,
        showPoly: true,
        showTempe: false, 
        showWest: true
      })
      this.props.parentCallBack(childData)

    }else if(childData === "polytechnic"){
      this.setState({ 
        showDowntown: true,
        showPoly: false,
        showTempe: true, 
        showWest: true
      })
      this.props.parentCallBack(childData)
    }else if(childData === "downtown"){
      this.setState({ 
        showDowntown: false,
        showPoly: true,
        showTempe: true, 
        showWest: true
      })
      this.props.parentCallBack(childData)
    }else if(childData === "west"){
      this.setState({ 
        showDowntown: true,
        showPoly: true,
        showTempe: true, 
        showWest: false
      })
      this.props.parentCallBack(childData)
    }
  }

  callbackFunction = (childData) => {
    this.hideCampus(childData)
  }

  render(){

    const { showPoly, showTempe, showWest, showDowntown } = this.state

    const row = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }
  
    const column = {
      flex: '33.33%',
      marginTop: 15,
      marginBottom: 0,
      textAlign: 'center'
    }
  
    const imgStyle = {
      marginTop: 20,
      width: '90%',
      cursor: 'pointer'
    }
    /*
    const header = {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
    */
    return (
    <div>
      <div style={row}>
      {
        showPoly && 
        <div style={column}>
          <Link to="/polytechnic" style={{ textDecoration: 'none', color: 'black' }}>
            <Heading text="polytechnic" parentCallBack={this.callbackFunction} />
          </Link>
          <Link to="/polytechnic">
          <picture>
            <source type="image/webp" srcSet={polytechnicWEBP} />
            <source type="image/jp2" srcSet={polytechnicJP2} />
            <source type="image/jxr" srcSet={polytechnicJXR} />
              <img src={polytechnicJPG} onClick={() => this.hideCampus("polytechnic")} style={imgStyle} loading="lazy"/>
          </picture>
          </Link>

        </div>
      }
      {
        showTempe && 
        <div style={column}>
          <Link to="/tempe" style={{ textDecoration: 'none' , color: 'black'}}>
            <Heading text="tempe" parentCallBack={this.callbackFunction}/>
          </Link>
          <Link to="/tempe">
          <picture>
            <source type="image/webp" srcSet={tempeWEBP} />
            <source type="image/jp2" srcSet={tempeJP2} />
            <source type="image/jxr" srcSet={tempeJXR} />
              <img src={tempeJPG} onClick={() => this.hideCampus("tempe")} style={imgStyle} loading="lazy"/>
          </picture>
          </Link>
        </div>
      }
      {
        showDowntown && 
        <div style={column}>
          <Link to="/downtown" style={{ textDecoration: 'none', color: 'black' }}>
            <Heading text="downtown" parentCallBack={this.callbackFunction} />
          </Link>
          <Link to="/downtown">
          <picture>
            <source type="image/jxr" srcSet={downtownJXR} />
            <source type="image/jp2" srcSet={downtownJP2} />
            <source type="image/webp" srcSet={downtownWEBP} />
              <img src={downtownJPG} onClick={() => this.hideCampus("downtown")} style={imgStyle} loading="lazy"/>
          </picture>
          </Link>
        </div>
      }
      {
        showWest && 
        <div style={column}>
          <Link to="/west" style={{ textDecoration: 'none', color: 'black' }}>
            <Heading text="west" parentCallBack={this.callbackFunction} />
          </Link>
          <Link to="/west">
          <picture>
            <source type="image/webp" srcSet={westWEBP} />
            <source type="image/jp2" srcSet={westJP2} />
            <source type="image/jxr" srcSet={westJXR} />
              <img src={westJPG} onClick={() => this.hideCampus("west")} style={imgStyle} loading="lazy"/>
          </picture>
          </Link>
        </div>
      }
      </div>
      <div style={column}>
         
      </div>
    </div>
    );
  }
}

export default ComingSoon;